












































// https://leafletjs.com/examples/crs-simple/crs-simple.html

import * as L from "leaflet";

import { Component, Prop, Vue } from "vue-property-decorator";
import {
  LCircleMarker,
  LIcon,
  LImageOverlay,
  LMap,
  LMarker,
  LPopup,
  LTooltip
} from "vue2-leaflet";
import { MapPlace } from "../interfaces/MapPlace";

@Component({
  components: {
    LCircleMarker,
    LIcon,
    LImageOverlay,
    LMap,
    LPopup,
    LMarker,
    LTooltip
  }
})
export default class ImageOverlayMap extends Vue {
  @Prop() private mapPlaces?: MapPlace[];
  private lMap?: LMap;
  private image = {
    url: `${process.env.VUE_APP_URI}/Carte/Map/Map.png`,
    width: 2519,
    height: 1500
  };
  private bounds = new L.LatLngBounds([
    [0, 0],
    [this.image.height, this.image.width]
  ]);
  private center: L.LatLngExpression = [
    this.image.height / 2,
    this.image.width / 2
  ];
  private crs = L.Util.extend({}, L.CRS.Simple, {
    transformation: new L.Transformation(this.factor, 0, this.factor, 0)
  });
  private minZoom = 0.6;
  private maxZoom = 2;
  private staticAnchor = [0, 0];

  private stars = [
    { name: "Center", lng: this.image.width / 2, lat: this.image.height / 2 },
    { name: "Top Left", lng: 0, lat: 0 },
    { name: "Top Right", lng: this.image.width, lat: 0 },
    { name: "Bottom Left", lng: 0, lat: this.image.height },
    { name: "Bottom Right", lng: this.image.width, lat: this.image.height }
  ];

  private circle = {
    radius: 12,
    color: "#e51b20"
  };

  private onReady() {
    this.lMap = this.$refs.leafletMap as LMap;
  }

  private get places() {
    let result: MapPlace[] = [];

    if (this.mapPlaces) {
      result = this.mapPlaces;
    }

    return result;
  }

  private get factor() {
    return 1000 / Math.max(this.image.height, this.image.width);
  }

  private onClick(id: string) {
    this.$router.push({ name: "place", params: { id: id } });
  }
}
